'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typography = require('./typography');

exports['default'] = {
  borderPaddingRightLeft: _typography.STEP / 2 - 1,
  borderPaddingTopBottom: parseInt((0, _typography.rhythmByUnit)(2)) - _typography.STEP / 2 - 1,
  borderRadius: _typography.RADIUS + 'em',
  borderWidth: 1,
  borderWidthFocused: 1,
  buttonBorderRadius: _typography.RADIUS * 2 + 'em',
  chipHeight: parseInt((0, _typography.rhythmByUnit)(3)) - _typography.STEP / 2,
  codeBorderRadius: _typography.RADIUS * 2 + 'em',
  contentPadding: '1em',
  drawerWidth: 270,
  drawerWidthLarge: 320,
  formControlMarginBottom: _typography.STEP,
  formControlMarginTop: parseInt((0, _typography.rhythmByUnit)(3)),
  iconHeight: '50px',
  inputBorderRadius: _typography.RADIUS * 1.155 + 'em',
  inputHeight: '2em',
  modalSheetHeaderHeight: '4em',
  searchInputHeight: parseInt((0, _typography.rhythmByUnit)(4)),
  skeletonCount: 10,
  tabPadding: (0, _typography.rhythmByUnit)(3),
  textFieldPadding: parseInt((0, _typography.rhythmByUnit)(3))
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/variables.js
// module id = 766
// module chunks = 32